function getKeyWidth(key) {
	switch (key) {
		case 'reason_for_concern':
			return 350;
		case 'label':
			return 200;
		default: 
			return 150;	
	}
}

export default function dynamicColumns(data, preferredSortOrder = []) {

  if (!data || !data.length) return [];

  // Get all unique keys from the data
  const keys = [...new Set(data.flatMap(item => Object.keys(item)))];

  // Separate keys into two arrays: those in the preferred sort order and those not
  const preferredKeys = [];
  const otherKeys = [];

  keys.forEach(key => {
	if (preferredSortOrder.includes(key)) {
	  preferredKeys.push(key);
	} else {
	  otherKeys.push(key);
	}
  });

  // Combine the preferred keys with the other keys in alphabetical order
  const allKeys = [...preferredKeys, ...otherKeys.sort()];

  return allKeys.map((key, index) => ({
	Header: key
	  .replace(/([A-Z])/g, ' $1')   // optional: camelCase -> Title Case
	  .replace(/^./, str => str.toUpperCase()),
	id: key,
	accessor: key,
	className: index == 0 ? 'table-text-left name-cell':'',
	headerClassName: index == 0 ? 'table-text-left':'',
	width: getKeyWidth(key)
  }));
}
